import React, { createContext } from 'react';

export const TranslationsContext = createContext({} as Translations);

interface TranslationsProviderProps {
  children: React.JSX.Element;
  translations: Translations;
}

export const TranslationsProvider = ({ children, translations }: TranslationsProviderProps): React.JSX.Element=> (
  <TranslationsContext.Provider value={translations}>{children}</TranslationsContext.Provider>
);
